function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { useCallback, useReducer } from "react";
var DEFAULT_PAGE_SIZE = 10;
var INITIAL_STATE = {
    pageSize: DEFAULT_PAGE_SIZE
};
var ACTIONS;
(function(ACTIONS) {
    ACTIONS["changePageSize"] = "CHANGE_PAGE_SIZE";
    ACTIONS["cursorPaginateBack"] = "CURSOR_PAGINATE_BACK";
    ACTIONS["cursorPaginateNext"] = "CURSOR_PAGINATE_NEXT";
    ACTIONS["filter"] = "FILTER";
    ACTIONS["paginate"] = "PAGINATE";
    ACTIONS["sort"] = "SORT";
})(ACTIONS || (ACTIONS = {}));
var reducer = function(state, action) {
    var resetCursor = {};
    switch(action.type){
        case "FILTER":
            {
                var resetPage = state.page ? {
                    page: 1
                } : {};
                resetCursor = state.cursor ? {
                    cursor: true,
                    cursorPoints: []
                } : {};
                var stateWithoutWhere = Object.entries(state).reduce(function(acc, param) {
                    var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
                    if (key.startsWith("where")) {
                        return acc;
                    }
                    return _object_spread_props(_object_spread({}, acc), _define_property({}, key, value));
                }, {});
                var whereClauses = {
                    where: {}
                };
                Object.keys(action.payload).forEach(function(key) {
                    if (key.startsWith("$")) {
                        whereClauses[key.substring(1)] = action.payload[key];
                    } else {
                        whereClauses["where"] = _object_spread_props(_object_spread({}, whereClauses.where), _define_property({}, key, action.payload[key]));
                    }
                });
                return _object_spread({}, stateWithoutWhere, resetPage, resetCursor, whereClauses);
            }
        case "PAGINATE":
            var _action_payload_page, _action_payload_pageSize;
            return _object_spread_props(_object_spread({}, state), {
                page: (_action_payload_page = action.payload.page) !== null && _action_payload_page !== void 0 ? _action_payload_page : state.page,
                pageSize: (_action_payload_pageSize = action.payload.pageSize) !== null && _action_payload_pageSize !== void 0 ? _action_payload_pageSize : state.pageSize
            });
        case "CHANGE_PAGE_SIZE":
            {
                var page = state.page, rest = _object_without_properties(state, [
                    "page"
                ]);
                resetCursor = state.cursor ? {
                    cursor: true,
                    cursorPoints: []
                } : {};
                var _action_payload;
                return _object_spread_props(_object_spread({}, rest, resetCursor), {
                    pageSize: (_action_payload = action.payload) !== null && _action_payload !== void 0 ? _action_payload : state.pageSize
                });
            }
        case "CURSOR_PAGINATE_NEXT":
            var _state_cursorPoints;
            return _object_spread_props(_object_spread({}, state), {
                cursor: action.payload.last,
                cursorPoints: ((_state_cursorPoints = state.cursorPoints) === null || _state_cursorPoints === void 0 ? void 0 : _state_cursorPoints.length) ? _to_consumable_array(state.cursorPoints).concat([
                    action.payload.last
                ]) : [
                    action.payload.first,
                    action.payload.last
                ]
            });
        case "CURSOR_PAGINATE_BACK":
            {
                var _state_cursorPoints1;
                var cursorPoints = _to_consumable_array((_state_cursorPoints1 = state.cursorPoints) !== null && _state_cursorPoints1 !== void 0 ? _state_cursorPoints1 : []).slice(0, -1);
                var cursor = cursorPoints[cursorPoints.length - 1];
                return _object_spread_props(_object_spread({}, state), {
                    cursor: cursor !== null && cursor !== void 0 ? cursor : state.cursor,
                    cursorPoints: cursorPoints
                });
            }
        case "SORT":
            var _action_payload1;
            return _object_spread_props(_object_spread({}, state), {
                orderBy: (_action_payload1 = action.payload) === null || _action_payload1 === void 0 ? void 0 : _action_payload1.map(function(item) {
                    return Object.entries(item).reduce(function(acc, param) {
                        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
                        if (key.includes(".")) {
                            var _key_split = _sliced_to_array(key.split("."), 2), outerKey = _key_split[0], innerKey = _key_split[1];
                            acc[outerKey] = _define_property({}, innerKey, value);
                        } else {
                            acc[key] = value;
                        }
                        return acc;
                    }, {});
                })
            });
        default:
            throw new Error("Invalid action.");
    }
};
export var useListControls = function() {
    var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _useReducer = _sliced_to_array(useReducer(reducer, _object_spread({}, INITIAL_STATE, initialState)), 2), listState = _useReducer[0], dispatch = _useReducer[1];
    var handleFilter = useCallback(function(filter) {
        dispatch({
            payload: filter,
            type: "FILTER"
        });
    }, []);
    var handlePaginate = useCallback(function(param) {
        var _param_page = param.page, page = _param_page === void 0 ? 1 : _param_page, pageSize = param.pageSize;
        dispatch({
            payload: {
                page: page,
                pageSize: pageSize
            },
            type: "PAGINATE"
        });
    }, []);
    var handleSort = useCallback(function(sort) {
        dispatch({
            payload: sort,
            type: "SORT"
        });
    }, []);
    var handleChangePageSize = useCallback(function(payload) {
        dispatch({
            payload: payload,
            type: "CHANGE_PAGE_SIZE"
        });
    }, []);
    var handleCursorPaginateNext = useCallback(function(first, last) {
        dispatch({
            payload: {
                first: first,
                last: last
            },
            type: "CURSOR_PAGINATE_NEXT"
        });
    }, []);
    var handleCursorPaginateBack = useCallback(function() {
        dispatch({
            type: "CURSOR_PAGINATE_BACK"
        });
    }, []);
    return {
        handleChangePageSize: handleChangePageSize,
        handleCursorPaginateBack: handleCursorPaginateBack,
        handleCursorPaginateNext: handleCursorPaginateNext,
        handleFilter: handleFilter,
        handlePaginate: handlePaginate,
        handleSort: handleSort,
        listState: listState
    };
};

//# sourceMappingURL=useListControls.js.map